var _defs, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 232,
    viewBox: "0 0 860 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Coach EMS \\u2014 Employee Management System",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lfBadge",
    x1: 60,
    y1: 36,
    x2: 452,
    y2: 476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B79CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6429C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lfKiss",
    cx: 0.86,
    cy: 0.12,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E9D5FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lfSpec",
    cx: 0.3,
    cy: 0.16,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lfArrow",
    x1: 280,
    y1: 300,
    x2: 400,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5D0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lfClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 24C150 24 96 24 60 60S24 150 24 256s0 106 36 142 90 36 196 36 106 0 142-36 36-90 36-196 0-106-36-142S362 24 256 24Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lfSh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 7,
    floodColor: "#2E1065",
    floodOpacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 22) scale(0.3672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 24C150 24 96 24 60 60S24 150 24 256s0 106 36 142 90 36 196 36 106 0 142-36 36-90 36-196 0-106-36-142S362 24 256 24Z",
    fill: "url(#lfBadge)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 24C150 24 96 24 60 60S24 150 24 256s0 106 36 142 90 36 196 36 106 0 142-36 36-90 36-196 0-106-36-142S362 24 256 24Z",
    fill: "url(#lfKiss)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lfClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -130,
    y: -40,
    width: 200,
    height: 640,
    transform: "rotate(22 256 256)",
    fill: "#FFFFFF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 120,
    rx: 190,
    ry: 120,
    fill: "url(#lfSpec)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lfSh)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 148,
    width: 48,
    height: 216,
    rx: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 148,
    width: 168,
    height: 48,
    rx: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 232,
    width: 118,
    height: 48,
    rx: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 316,
    width: 168,
    height: 48,
    rx: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 300 L322 264 L346 286 L392 232",
    fill: "none",
    stroke: "url(#lfArrow)",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 232 L356 230 M392 232 L394 268",
    fill: "none",
    stroke: "url(#lfArrow)",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 248,
    y: 128,
    fontFamily: "'Inter','Segoe UI',system-ui,-apple-system,'Helvetica Neue',Arial,sans-serif",
    fontSize: 92,
    fontWeight: 800,
    letterSpacing: -2
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#0F172A"
  }, "Coach"), /*#__PURE__*/React.createElement("tspan", {
    dx: 22,
    fill: "#7C3AED"
  }, "EMS"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 176,
    fontFamily: "'Inter','Segoe UI',system-ui,-apple-system,'Helvetica Neue',Arial,sans-serif",
    fontSize: 24,
    fontWeight: 600,
    letterSpacing: 6.5,
    fill: "#64748B"
  }, "EMPLOYEE MANAGEMENT SYSTEM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.7027829f242f408ad9eda675147cd5a7.svg";
export { ForwardRef as ReactComponent };